import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import { IntlProvider } from 'react-intl';
import translations from 'translate/all';
import { configs } from './configs';
import BrowserDetection from 'react-browser-detection';
const metaData = {
  title: 'Scrolling Results',
  link:  {
    rel: {
      stylesheet: [
        configs.scrollingUrl + '/public/reset.css',
        configs.scrollingUrl + '/css/main.css',
        'https://fonts.googleapis.com/css?family=Ubuntu|Source+Sans+Pro|Open+Sans|Roboto|Montserrat'
      ]
    }
  },
  meta: {
    charset: 'utf-8',
      name: {
        viewport: 'width=device-width, initial-scale=1'
      }
  }
};

const browserHandler = {
  ie: () => <div className='ie'>Panels work best when using Chrome! <a href='https://www.google.com/chrome/'>Download here!</a></div>,
  default: () => <div></div>
};
export class App extends Component {
  render() {
    //set translation messages
  const { params } = this.props;
  let { lc = 'en' } = params;
  const translation = translations[lc];
    return (
      <div>
        <DocumentMeta {...metaData} />
        <BrowserDetection>
          { browserHandler }
        </BrowserDetection>
        <IntlProvider locale={lc} messages={translation.messages}>
          {this.props.children}
        </IntlProvider>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./App.js